export function trigger(category, action, label) {
    if (window.dataLayer && category && action && typeof label !== 'undefined') {
        window.dataLayer.push({
            event: 'gaTriggerEvent',
            gaEventCategory: category,
            gaEventAction: action,
            gaEventLabel: label
        });
    }
}

export function bindDatasetListener() {
    [...document.querySelectorAll('[data-evt-category]')].forEach(function($category) {
        $category.addEventListener('click', event => datasetListener(event, trigger));
    }, true);
}

export function datasetListener(event, callback) {
    let target = event.target,
        {evtCategory, evtAction, evtLabel} = {
            ...event.currentTarget.dataset,
            ...target.dataset
        },
        found = false;

    if (evtCategory && evtAction) {
        if (evtLabel) {
            callback(evtCategory, evtAction, evtLabel);
            return;
        }

        while (!found && target && target !== event.currentTarget && !evtLabel) {
            if (/a|button/i.test(target.nodeName)) {
                evtLabel = target.dataset.evtLabel || target.innerText.trim();
                callback(evtCategory, evtAction, evtLabel);
                found = true;
            } else {
                target = target.parentElement;
            }
        }
    }
}
